var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFreshdeskMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "g14")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-1307.000000, -6378.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1283.000000, 6354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9181818,-0.000250574029 L41.9454545,-0.000250574029 C43.5556832,-0.0147062069 45.1042398,0.618458034 46.2428909,1.75710909 C47.381542,2.89576015 48.0147062,4.44431684 48.0002506,6.05454545 L48.0002506,24.0818182 C48.0002506,37.2914652 37.2914652,48.0000156 24.0818182,48.0000156 L23.9454545,48.0000156 C17.5972343,48.0072386 11.5065424,45.4904904 7.01511288,41.0041764 C2.52368335,36.5178624 3.87568765e-15,30.4300425 3.87568765e-15,24.0818182 C3.87568765e-15,10.8272727 10.6909091,0.136363636 23.9181818,-0.000250574029 Z",
    id: "path10",
    fill: "#25C16F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9181818,10.6909091 C17.8480703,10.6909091 12.9272727,15.6117067 12.9272727,21.6818182 L12.9272727,29.1545455 C12.9706118,31.1546685 14.5816951,32.7657518 16.5818182,32.8090909 L19.6909091,32.8090909 L19.6909091,24.2181818 L15.4909091,24.2181818 L15.4909091,21.8181818 C15.7466956,17.2982804 19.4865031,13.7641293 24.0136364,13.7641293 C28.5407697,13.7641293 32.2805771,17.2982804 32.5363636,21.8181818 L32.5363636,24.2181818 L28.2818182,24.2181818 L28.2818182,32.8090909 L31.0909091,32.8090909 L31.0909091,32.9454545 C31.0616834,34.8009407 29.564577,36.2980471 27.7090909,36.3272727 L24.3545455,36.3272727 C24.0818182,36.3272727 23.7818182,36.4636364 23.7818182,36.7363636 C23.7956342,37.0467694 24.0441397,37.2952749 24.3545455,37.3090909 L27.7363636,37.3090909 C30.1401411,37.2942064 32.0851155,35.349232 32.1,32.9454545 L32.1,32.6727273 C33.7546355,32.3001816 34.9248145,30.8232567 34.9090909,29.1272727 L34.9090909,21.8181818 C35.0454545,15.6272727 30.1363636,10.6909091 23.9181818,10.6909091 Z",
    id: "path12",
    fill: "#FFFFFF"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFreshdeskMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/freshdesk-mark.f50c669b.svg";
export { ForwardRef as ReactComponent };